// extracted by mini-css-extract-plugin
module.exports = {"red":"style_red__H22z3","green":"style_green__F5heq","titleClassName":"style_titleClassName__8qjMP"};